export const DESKTOP_GRAPH_ITEM_WIDTH = 46;
